import { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { ITaxComponents } from "./TaxComponentsController";
import {
  fetchTaxComponentById,
  getTaxCategoryDdl,
  handleSubmitTaxComponent,
  ITaxComponentForm,
  TAX_COMPONENT_INITIAL_VALUES,
  taxComponentValidationSchema,
} from "./TaxComponentsFormController";
import { hasAnyModification } from "../../utils/AppFunctions";
import {
  FormRightModalWrapper,
  ICButton,
  ICConfirmationModal,
  Loader,
} from "../../core-component/ui";
import { Formik, Form } from "formik";
import {
  ICFormikDropDown,
  ICFormikTextInput,
} from "../../core-component/formik";
import { IOption } from "../../data/AppInterface";

interface ITaxComponentFormProps {
  handleClose: (status: boolean) => void;
  readOnly: boolean;
  taxComponentToEdit?: ITaxComponents;
}

const TaxComponentForm: React.FC<ITaxComponentFormProps> = ({
  handleClose,
  readOnly,
  taxComponentToEdit,
}) => {
  const { t } = UseTranslationHook();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showDiscardWarning, setShowDiscardWarning] = useState(false);
  const [taxComponentFormInitialValues, setTaxComponentFormInitialValues] =
    useState<ITaxComponentForm>();
  const [taxCategory, setTaxCategory] = useState<IOption<number>[]>([]);

  useEffect(() => {
    if (taxComponentToEdit) {
      getTaxComponentFieldById(taxComponentToEdit.id);
    } else {
      setTaxComponentFormInitialValues(TAX_COMPONENT_INITIAL_VALUES);
    }
    fetchTaxCategory();
  }, []);

  const getTaxComponentFieldById = async (id: string) => {
    setLoading(true);
    await fetchTaxComponentById(
      id,
      handleClose,
      setTaxComponentFormInitialValues
    );
    setLoading(false);
  };
  const fetchTaxCategory = async () => {
    setLoading(true);
    await getTaxCategoryDdl(setTaxCategory);
    setLoading(false);
  };
  const checkFormModification = (values: ITaxComponentForm) => {
    if (
      taxComponentFormInitialValues &&
      hasAnyModification(values, taxComponentFormInitialValues)
    ) {
      setShowDiscardWarning(true);
    } else {
      handleClose(false);
    }
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {taxComponentFormInitialValues && (
            <Formik
              initialValues={taxComponentFormInitialValues}
              validationSchema={taxComponentValidationSchema(t)}
              onSubmit={(values) => {
                handleSubmitTaxComponent(
                  { ...values, rate: Number(values.rate) },
                  setSubmitLoading,
                  taxComponentToEdit?.id,
                  handleClose
                );
              }}
            >
              {(formikPorps) => {
                const { handleSubmit, values } = formikPorps;

                return (
                  <FormRightModalWrapper
                    containerClassName="!w-1/4"
                    onClose={() => checkFormModification(values)}
                    title={t("tax_component")}
                  >
                    <Form
                      onSubmit={handleSubmit}
                      className="flex flex-col h-full"
                    >
                      <div className="flex-1 space-y-4">
                        <ICFormikTextInput
                          {...formikPorps}
                          fieldName={"name"}
                          placeholder={t("name")}
                          required
                          tabIndex={0}
                          disabled={readOnly}
                        />
                        <ICFormikTextInput
                          {...formikPorps}
                          type="number"
                          fieldName={"rate"}
                          placeholder={t("rate_percentage")}
                          required
                          disabled={readOnly}
                        />
                        <ICFormikDropDown
                          {...formikPorps}
                          name={"tax_category_id"}
                          placeholder={t("tax_category")}
                          options={taxCategory}
                          required
                          searchable
                          disabled={readOnly}
                        />
                      </div>
                      {!readOnly && (
                        <ICButton
                          loading={submitLoading}
                          className={"w-full"}
                          children={t("submit")}
                        />
                      )}
                    </Form>
                  </FormRightModalWrapper>
                );
              }}
            </Formik>
          )}
          {showDiscardWarning && (
            <ICConfirmationModal
              title={t("discard_warning")}
              message={t("discard_unsaved_changes")}
              onClose={(value) => {
                setShowDiscardWarning(false);
                value && handleClose(false);
              }}
            />
          )}
        </>
      )}
    </>
  );
};
export default TaxComponentForm;
